import { JurisdictionListItem } from "./jurisdiction-list-item.model";

export class LegalEntityListItem {
    id: string;
    name: string;
    code: string;
    isActive: boolean;
    jurisdictions: JurisdictionListItem[];
}